import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.starts-with";
import _slicedToArray from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/slicedToArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import _defineProperty from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ActivityList from "./ActivityList";
import { showErrorMessage } from "../functions/my-functions";
import MyReadMore from 'src/components/ReadMoreComponent';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { transform } from 'ol/proj';
export default {
  props: ['area'],
  components: {
    ActivityList: ActivityList,
    MyReadMore: MyReadMore
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  filters: {
    formatDate: function formatDate(value) {
      if (value) {
        return moment(new Date(value)).format('LLL');
      }
    }
  },
  computed: _objectSpread({}, mapGetters(['userid'])),
  methods: {
    areaActivities: function areaActivities(area) {
      var results = [];

      for (var _i = 0, _Object$entries = Object.entries(area); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        if (key.startsWith('act_') && value === true) {
          results.push(key);
        }
      }

      return results;
    },
    showOnMap: function showOnMap() {
      var mapRef = 'map';
      var map = this.$refs[mapRef].$map;
      var view = map.getView();
      var coords = transform(view.getCenter(), 'EPSG:3857', 'EPSG:4326');
      this.$router.push({
        name: 'map',
        params: {
          centerProp: coords,
          zoomProp: view.getZoom()
        }
      });
    },
    onClickEdit: function onClickEdit() {
      this.$router.push({
        path: "/area/".concat(this.area.id, "/edit")
      });
    },
    onClickRemove: function onClickRemove() {
      var _this = this;

      var that = this;
      this.$q.dialog({
        dark: false,
        nocaps: true,
        title: this.$t('pages.timeline.delete_title'),
        message: this.$t('pages.timeline.delete_subtitle'),
        cancel: {
          flat: true,
          'no-caps': true,
          label: this.$t('buttons.cancel')
        },
        ok: {
          color: 'red',
          flat: true,
          icon: 'delete',
          'no-caps': true,
          label: this.$t('buttons.delete')
        },
        persistent: true
      }).onOk(function () {
        _this.$meteor.call('measure.delete', _this.area._id, function (err) {
          _this.$q.loading.show({
            delay: 400 // ms

          });

          if (err) {
            _this.$q.loading.hide();

            showErrorMessage(err.reason);
          } else {
            _this.$q.loading.hide();

            _this.$q.notify({
              message: that.$t('messages.area_deleted'),
              color: 'positive'
            });
          }
        });
      });
    },
    onSourceCreated: function onSourceCreated() {
      // console.log("onSourceCreated:" + this.area.id)
      var mapRef = 'map';
      var featureSourceRef = 'featureSource';
      var map = this.$refs[mapRef].$map;
      var featureSource = this.$refs[featureSourceRef];
      var theSource = featureSource.$source;
      theSource.once('change', function (e) {
        if (theSource.getState() === 'ready') {
          var extent = theSource.getExtent();
          map.getView().fit(extent, map.getSize());
        }
      });
    },
    onMapMounted: function onMapMounted() {
      var map = this.$refs['map'].$map;
      map.getControls().extend([]);
    }
  }
};